module.exports = __webpack_public_path__ + "static/media/message_sent.2f01606b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/message_sent.svg
// module id = 776
// module chunks = 0